<template>
  <div class="list">
    <form action="/">
      <van-search
        v-model="searchKey"
        placeholder="请输入搜索关键词"
        show-action
        shape="round"
        @search="onSearch"
        @cancel="onSearchCancel"
      />
    </form>

    <van-pull-refresh v-model="refreshing" @refresh="onLoad">
      <div style="min-height: 90vh">
        <ListItem v-for="item in showList" :key="item.id" :value="item" :type="listType"/>
      </div>

    </van-pull-refresh>

  </div>
</template>

<script>
import ListItem from "./listItem";
import {
  Search,
  List,
  PullRefresh,
  Dialog
} from 'vant';

export default {
  components: {
    ListItem,
    [Search.name]: Search,
    [List.name]: List,
    [PullRefresh.name]: PullRefresh
  },
  data() {
    return {
      searchKey: '',
      resultList: [],
      showList: [],
      refreshing: false,
      listType: 'mine'
    };
  },

  methods: {
    onSearch() {
      if (!this.resultList || this.resultList.length == 0) {
        return
      } else {
        this.showList = []
        this.resultList.forEach(re => {
          if (JSON.stringify(re).includes(this.searchKey))
            this.showList.push(re)
        })
      }
    },
    onSearchCancel() {
      this.showList = this.resultList
    },
    onLoad() {
      if (this.refreshing) {
        this.resultList = [];
        this.refreshing = false;
      }

      this.$axios.get('asset/' + this.listType).then(res => {
        this.showList = this.resultList = res
      }).catch(res => {
        Dialog.alert({
          title: '获取资产列表失败',
          message: res
        }).then(() => {
          this.loading = false;
        })
      })
    }
  },
  mounted() {
    this.listType = this.$route.name || 'mine'
    this.onLoad()
  }
};
</script>

<style lang="less">
.list {
  background-color: #F7F8FA;
  .card {

  }

  &-assetDetail {
    padding: 10px 20px;
  }

  &-img {
    margin-left: 40px;
  }

  &-submit {
    text-align: center;
    button {
      padding: 0 50px;
      margin: 20px auto;
    }
  }



  &-swipe {
    img {
      width: 100%;
      display: block;
    }
  }

  &-title {
    font-size: 16px;
  }

  &-price {
    color: #f44;
  }

  &-express {
    color: #999;
    font-size: 12px;
    padding: 5px 15px;
  }

  &-cell-group {
    margin: 15px 0;

    .van-cell__value {
      color: #999;
    }
  }

  &-tag {
    margin-left: 5px;
  }
}
</style>
